import { render, staticRenderFns } from "./HistoricalDataCityDashboard.vue?vue&type=template&id=489efcb8&"
import script from "./HistoricalDataCityDashboard.vue?vue&type=script&lang=js&"
export * from "./HistoricalDataCityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalDataCityDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports